import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import DiamondReportsShapeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsShapeComp";
import DiamondReportsClarityComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsClarityComp";
import DiamondReportsCertificateComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsCertificateComp";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminDiamondReportService from "../../../services/reports-AdminDiamond-service";
import DiamondReportsCutGradeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsCutGradeComp";
import DiamondReportsColorComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsColorComp";
import DiamondReportsSizeComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsSizeComp";
import DiamondReportsPriceComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsPriceComp";
import ReportKpiBand from "../../ChartsGroup/DiamondReportsCharts/ReportKpiBand";
import ReportInsight from "../../ChartsGroup/DiamondReportsCharts/ReportInsight";
import ReportTabs from "../../ChartsGroup/DiamondReportsCharts/ReportTabs";
import GlobalDiamondReportService from "../../../services/reports-globalDiamond-service";
import { DatePicker, Select } from "antd";
import DiamondCutComp from "../../ChartsGroup/DiamondCutComp";
import DiamondReportsClicksComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsClicksComp";
const { RangePicker } = DatePicker;
const { Option } = Select;

const ExtendedDiamondChartReports = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);

  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [forDealer, setForDealer] = useState("");
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [checkingMembership, setCheckingMembership] = useState(true);
  const [report, setReport] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };
    AdminDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          setCheckingMembership(false);
          handleLoadChartReports(id, forDealer);
        } else {
          setForDealer("");
          setCheckingMembership(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setForDealer("");
        setCheckingMembership(false);
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "Global",
      reportName: "ExtDiamondChrt",
    };
    setLoadChartReportsLoading(true);
    setLoadError(false);

    AdminDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success" && Object.keys(responseData).length !== 0) {
          setReport(responseData);
        } else {
          setReport(null);
          setLoadError(true);
        }
      })
      .catch((error) => {
        setReport(null);
        setLoadError(true);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleOnChange = (e, isSelect, name) => {
    let vId = "";
    let rId = "";
    if (isSelect === "select" && name === "vendors") {
      vId = e.includes(0) ? [0] : e;
      setGlobalDiamond((prevState) => {
        const updatedState = { ...prevState, vendorIds: vId };
        if (
          updatedState.vendorIds.length === 0 &&
          updatedState.retailerIds?.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeRetailerListHandler(vId);
        }

        return updatedState;
      });
    } else if (isSelect === "select" && name === "retailers") {
      rId = e.includes(0) ? [0] : e;
      setGlobalDiamond((prevState) => {
        const updatedState = { ...prevState, retailerIds: rId };
        if (
          updatedState.vendorIds?.length === 0 &&
          updatedState.retailerIds.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeVendorListHandler(rId);
        }

        return updatedState;
      });
    } else {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        [name]: e,
      }));
    }
  };

  const handleGetVendorDropdownData = () => {
    GlobalDiamondReportService.GetVendors()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setVendorList(responseData.Table);
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        setVendorList([]);
      });
  };

  const handleGetRetailerDropdownData = () => {
    GlobalDiamondReportService.GetRetailers()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.Table);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };

  const changeRetailerListHandler = (data) => {
    data = data.toString();
    let inputData = {
      vendorsID: data,
    };
    GlobalDiamondReportService.GetRetailersOnVendorDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.retailers);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };
  const changeVendorListHandler = (data) => {
    data = data.toString();
    let inputData = {
      retailerID: data,
    };
    GlobalDiamondReportService.GetVendorsOnRetailerDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            if (responseData.vendors !== null) {
              setVendorList(responseData.vendors);
            }
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setVendorList([]);
      });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };


  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="edr-pagehead-row">
              <div className="edr-pagehead">
                <h1 className="edr-pagehead-title">
                  {t("Extended Diamond Chart Reports")}
                </h1>
                <div className="edr-pagehead-sub">
                  {t("Search & engagement analytics")} ·{" "}
                  {moment(globalDiamonds.dataRangeFrom).format("MMM D, YYYY")}{" "}
                  – {moment(globalDiamonds.dataRangeTo).format("MMM D, YYYY")}
                </div>
              </div>
              <button className="primary-btn" onClick={handleApplyFilter}>
                {t("Apply Filter")}
              </button>
            </div>
          </div>

          <div className="col-md-12">
            <div className="row edr-filters">
              <div className="col-md-3">
                <div className="input__block dataRange-input-block datepicker__block">
                  <label> {t("Date Range")} </label>
                  <RangePicker
                    className="date-range-input"
                    ranges={{
                      Today: [moment(), moment()],
                      Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days"),
                      ],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                      "Last 30 Days": [moment().subtract(30, "days"), moment()],
                      "This Month": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "months").endOf("month"),
                      ],
                      "Last 90 Days": [moment().subtract(90, "days"), moment()],
                      "Year To Date": [moment().startOf("year"), moment()],
                    }}
                    format={"MM-DD-YYYY"}
                    onChange={onDateChange}
                    defaultValue={[moment().subtract(30, "days"), moment()]}
                    defaultPickerValue={[moment().subtract(30, "days"), moment()]}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Select Diamond")} </label>
                  <Select
                    className="border__grey"
                    placeholder={t("All")}
                    showSearch
                    name="SelectedDiamondValue"
                    optionFilterProp="children"
                    value={
                      globalDiamonds.SelectedDiamondValue
                        ? globalDiamonds.SelectedDiamondValue
                        : null
                    }
                    onChange={(e) =>
                      handleOnChange(e, "select", "SelectedDiamondValue")
                    }
                  >
                    <Option value="All"> {t("All")} </Option>
                    <Option value="Mined"> {t("Mined Diamond")} </Option>
                    <Option value="Lab"> {t("Lab Grown Diamond")} </Option>
                  </Select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Vendor(s)")} </label>
                  <Select
                    className="border__grey"
                    showSearch
                    mode="multiple"
                    showArrow
                    placeholder={t("Select one or more vendor")}
                    optionFilterProp="children"
                    value={globalDiamonds.vendorIds}
                    onChange={(e) => handleOnChange(e, "select", "vendors")}
                  >
                    {vendorList.length > 0 &&
                      vendorList.map((item, key) => {
                        return (
                          <Option key={item.dealerID} value={item.dealerID}>
                            {" "}
                            {item.dealercompany}{" "}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="input__block">
                  <label> {t("Retailer(s)")} </label>
                  <Select
                    showSearch
                    showArrow
                    className="border__grey"
                    placeholder={t("Select one or more retailer ")}
                    optionFilterProp="children"
                    onChange={(e) => handleOnChange(e, "select", "retailers")}
                    notFoundContent={t("No Data Found")}
                    mode="multiple"
                    value={globalDiamonds.retailerIds}
                  >
                    {retailerList.length > 0 &&
                      retailerList.map((item, key) => {
                        return (
                          <React.Fragment>
                            <Option key={item.dealerID} value={item.dealerID}>
                              {" "}
                              {item.dealercompany}{" "}
                            </Option>
                          </React.Fragment>
                        );
                      })}
                  </Select>
                </div>
              </div>
            </div>
          </div>

          {forDealer && loadError && (
            <div className="col-md-12">
              <div className="no-report-render">
                <div className="desc-space">
                  <h4 className="text-center">
                    {t("Couldn't load the report. Please try again.")}
                  </h4>
                </div>
              </div>
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportKpiBand
                report={report}
                loading={checkingMembership || LoadChartReportsLoading}
                dataRangeFrom={globalDiamonds.dataRangeFrom}
                dataRangeTo={globalDiamonds.dataRangeTo}
              />
              <ReportInsight report={report} />
            </div>
          )}

          {(forDealer || checkingMembership) && !loadError && (
            <div className="col-md-12">
              <ReportTabs
                overview={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsShapeComp
                        data={report?.DiamondShapeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsColorComp
                        data={report?.DiamondColorSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                attributes={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsCutGradeComp
                        data={report?.DiamondCutGradeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsCertificateComp
                        data={report?.DiamondCertificateSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <DiamondCutComp
                      globalDiamonds={globalDiamonds}
                      mainForDealer={forDealer}
                      isApplyFilter={isApplyFilter}
                      isGlobalScope
                    />
                    <div className="col-lg-12">
                      <DiamondReportsClarityComp
                        data={report?.DiamondClaritySearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                commercial={
                  <>
                    <div className="col-lg-6">
                      <DiamondReportsPriceComp
                        data={report?.DiamondPrice}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                    <div className="col-lg-6">
                      <DiamondReportsSizeComp
                        data={report?.DiamondSizeSearches}
                        loading={checkingMembership || LoadChartReportsLoading}
                      />
                    </div>
                  </>
                }
                trend={
                  <div className="col-lg-12">
                    <DiamondReportsClicksComp
                      data={report?.DiamondClicks}
                      loading={checkingMembership || LoadChartReportsLoading}
                    />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExtendedDiamondChartReports;
